<template>
  <div class="l-page l-page--conversion-all">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main">
      <div class="l-main-head">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" :additional-classes="['p-breadcrumb--conversion-all']" />
      </div>
      <div class="l-main-content">
        <div class="p-conversion-all-summary">
          <div class="c-title">
            <div class="c-title__text u-fs34">{{ trimEllipTitle }} の成果</div>
            <div class="c-date u-w420">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ formattedFrom }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ formattedTo }}</li>
              </ul>
            </div>
          </div>
          <!-- metrics -->
          <div class="p-conversion-all-summary__metrics">
            <div class="p-metrics-summary">
              <ul class="p-metrics-summary-list">
                <li class="p-metrics-summary-list__item" :class="isLoding.metrics ? 'is-loading' : ''">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--total_cv is-active">
                    <dt class="c-metrics__label">合計CV数</dt>
                    <dd class="c-metrics__value">{{ metrics.total_cv }}</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">{{ metrics.total_cv_diff }}</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item" :class="isLoding.metrics ? 'is-loading' : ''">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--unique_cv is-active">
                    <dt class="c-metrics__label">ユニークCV数</dt>
                    <dd class="c-metrics__value">{{ metrics.unique_cv }}</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">{{ metrics.unique_cv_diff }}</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item" :class="isLoding.metrics ? 'is-loading' : ''">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--optin_user_cv">
                    <dt class="c-metrics__label">通知許諾ユーザーCV数</dt>
                    <dd class="c-metrics__value">{{ metrics.optin_user_cv }}</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">{{ metrics.optin_user_cv_diff }}</p>
                    </dd>
                  </dl>
                </li>
                <li class="p-metrics-summary-list__item" :class="isLoding.metrics ? 'is-loading' : ''">
                  <div class="c-loader c-loader--small"></div>
                  <dl class="c-metrics c-metrics--optout_user_cv">
                    <dt class="c-metrics__label">非通知許諾ユーザーCV数</dt>
                    <dd class="c-metrics__value">{{ metrics.optout_user_cv }}</dd>
                    <dd class="c-metrics__state-diff">
                      <p class="c-metrics__state-diff-text">前回期間からの増減</p>
                      <p class="c-metrics__state-diff-value">{{ metrics.optout_user_cv_diff }}</p>
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>
          </div>
          <!-- /metrics -->
          <div class="p-conversion-all-summary__data" :class="isLoding.graph ? 'is-loading' : ''">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">計測後にデータが反映されます</div>
            </div>
            <svg class="c-graph-line c-graph-line--summary-conversion">
              <defs>
                <clipPath id="clipPath">
                  <rect
                    x="15"
                    y="0"
                    height="330"
                    width="930"
                  />
                </clipPath>
              </defs>
              <g class="c-graph-line-frame" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-frame__rect"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
                <line
                  class="c-graph-line-frame__line"
                  x1="15"
                  x2="945"
                  y1="330"
                  y2="330"
                />
              </g>
              <g class="c-graph-line-bg" clip-path="url(#clipPath)">
                <g class="c-graph-line-bg__x" />
                <g class="c-graph-line-bg__y" />
              </g>
              <g class="c-graph-line-chart" clip-path="url(#clipPath)" />
              <g class="c-graph-line-pointer" clip-path="url(#clipPath)">
                <rect
                  class="c-graph-line-pointer__area"
                  x="15"
                  y="0"
                  height="330"
                  width="930"
                />
              </g>
              <g class="c-graph-line-axis">
                <g class="c-graph-line-axis__x" />
                <g class="c-graph-line-axis__y--left" />
                <g class="c-graph-line-axis__y--right" />
              </g>
              <g class="c-graph-line-label" />
            </svg>
            <div class="c-tooltip c-tooltip--graph-line c-tooltip--summary-conversion">
              <div class="c-tooltip__title">-</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--total_cv">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--unique_cv">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--optin_user_cv">-</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--optout_user_cv">-</li>
              </ul>
            </div>
          </div>
          <div class="p-conversion-all-summary__data-table" :class="isLoding.metrics ? 'is-loading' : ''">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">計測後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--summary-group">
              <thead>
                <tr>
                  <th class="c-table__cell--center">
                    <span class="c-table__text">CV時間</span>
                  </th>
                  <th class="c-table__cell--center u-w190">
                    <span class="c-table__text">合計CV数</span>
                  </th>
                  <th class="c-table__cell--center u-w190">
                    <span class="c-table__text">ユニークCV数</span>
                  </th>
                  <th class="c-table__cell--center u-w190">
                    <span class="c-table__text">通知許諾ユーザーCV数</span>
                  </th>
                  <th class="c-table__cell--center u-w190">
                    <span class="c-table__text">非通知許諾ユーザーCV数</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, loopIndex1) in conversions" :key="loopIndex1">
                  <td class="c-table__cell--center c-table__cell--middle">{{ formatHour(item.date) }}</td>
                  <td class="c-table__cell--center c-table__cell--middle">{{ item.total_cv }}</td>
                  <td class="c-table__cell--center c-table__cell--middle">{{ item.unique_cv }}</td>
                  <td class="c-table__cell--center c-table__cell--middle">{{ item.optin_user_cv }}</td>
                  <td class="c-table__cell--center c-table__cell--middle">{{ item.optout_user_cv }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal :is-active=isError :message=errorMessage :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  props: {
    breadcrumbData: Array,
    conversionValue: String,
    date: String
  },
  data() {
    return {
      errorMessage: '',
      isActiveCalendarModal: false,
      isError: false,
      params: {
        from: dayjs(this.date).format(),
        to: dayjs(this.date).format(),
      },
      metrics: {
        total_cv: '-',
        unique_cv: '-',
        optin_user_cv: '-',
        optout_user_cv: '-',
        total_cv_diff: '-',
        unique_cv_diff: '-',
        optin_user_cv_diff: '-',
        optout_user_cv_diff: '-',
      },
      conversions: [],
      updateGraph: null,
      isLoding: {
        metrics: true,
        graph: true,
        conversions: true,
      }
    }
  },
  computed: {
    formattedFrom: function () {
      return dayjs(this.date).format('YYYY/MM/DD');
    },
    formattedTo: function () {
      return dayjs(this.date).format('YYYY/MM/DD');
    },
    trimEllipTitle: function () {
      return this.conversionValue.length > 10 ? this.conversionValue.substring(0, 10) + '...' : this.conversionValue;
    }
  },
  mounted: function () {
    const period = { from: this.formatDate(this.date), to: this.formatDate(this.date) };
    const conversionValue = this.conversionValue;
    import('../../funcs/pages/conversion-time-group').then(module => {
      this.updateGraph = module.Conversion();
      this.updateGraph(period, conversionValue, () => { this.isLoding.graph = false; });
    });
    this.getMetrics(this.params);
    this.getConversions(this.params);
  },
  methods: {
    formatDate: function (dt) {
      return dayjs(dt).format('YYYY-MM-DD');
    },
    formatHour: function (dt) {
      return dayjs(dt).format('HH');
    },
    getMetrics: function (period) {
      const url = '/api/conversion/metrics-summary-time';
      const params = {
        from: this.formatDate(period.from),
        to: this.formatDate(period.to),
        conversion_value: this.conversionValue,
      };
      this.isLoding.metrics = true;
      axios.get(url, { params: params })
        .then((response) => {
          const data = response.data;
          this.metrics = data.items;
          this.isLoding.metrics = false;
        })
        .catch((error) => {
          this.isError = true;
          this.errorMessage = error.response.data.message;
        });
    },
    getConversions: function (period) {
      const url = '/api/conversion/summary-group-time';
      const params = {
        from: this.formatDate(period.from),
        to: this.formatDate(period.to),
        conversion_value: this.conversionValue,
      };
      this.isLoding.conversions = true;
      axios.get(url, { params: params })
        .then((response) => {
          this.isLoding.conversions = false;
          const data = response.data;
          this.conversions = data.items;
        })
        .catch((error) => {
          this.isError = true;
          this.errorMessage = error.response.data.message;
        });
    },
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function () {
      this.isError = false
      this.errorMessage = ''
    },
  }
}
</script>
